import { useNavigate } from 'react-router-dom';
import axios from "axios";
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import '../../App.css';

export default function Documents() {
    useEffect(() => {
        document.title = "Documents";
    }, []);

    const [dataCounts, setDataCounts] = useState({
        fullyPaid: 0,
        pendingBalance: 0,
        total: 0,
        archived: 0,
    });

    const [example_data, setExample] = useState([
        {
            pfpPath: "https://via.placeholder.com/40",
            requestedAt: "30-10-2024",
            releasedAt: "30-10-2024",
            requester: "Jane Doe",
            owner: "",
            ownerId: "01-0002-00000",
            purpose: "Transfer schools",
            requestedDoc: "Academic Records",
            requestedType: "Personal Information",
            statusPayment: "Paid",
            statusProcess: "Processing",
            daysOverdue: 3,
        },
        {
            pfpPath: "https://via.placeholder.com/40",
            requestedAt: "30-10-2024",
            releasedAt: "30-10-2024",
            requester: "John Doe",
            owner: "",
            ownerId: "01-0001-00000",
            purpose: "Personal reference",
            requestedDoc: "Academic Records",
            requestedType: "Personal Information",
            statusPayment: "Paid",
            statusProcess: "In Transit",
            daysOverdue: 3,
        },
    ]);

    const [documents_data, setDocuments] = useState(example_data);
    const [searchValue, setSearchValue] = useState("");
    const [pageNow, setPageNow] = useState(1);
    const rowsNow = 15;

    const handleSearchChange = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setSearchValue(searchQuery);
        const filteredBySearch = example_data.filter((request) =>
            Object.values(request).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setDocuments(filteredBySearch);
        setPageNow(1);
    };

    const paginatedRequests = documents_data.slice(
        (pageNow - 1) * rowsNow,
        pageNow * rowsNow
    );
    const pageTotal = Math.ceil(documents_data.length / rowsNow);
    const pageNumbers = Array.from({ length: pageTotal }, (_, i) => i + 1);

    const pagePrev = () => pageNow > 1 && setPageNow(pageNow - 1);
    const pageNext = () => pageNow < pageTotal && setPageNow(pageNow + 1);
    const changePage = (id) => setPageNow(id);

    const navigate = useNavigate();
    const handleNavigation = (path) => navigate(path);

    return (
        <div>
            <header className="header">
                <h1>Documents</h1>
                <input
                    type="text"
                    placeholder="Search"
                    value={searchValue}
                    onChange={handleSearchChange}
                    className="search-input"
                />
            </header>

            <Container>
                <Row className="g-4">
                    {paginatedRequests.length > 0 ? (
                        paginatedRequests.map((doc, index) => (
                            <Col xs={12} sm={6} md={4} lg={3} key={index}>
                                <Card
                                    onClick={() =>
                                        handleNavigation(`/document/${doc.id}`)
                                    }
                                    className="document-card"
                                >
                                    <Card.Img
                                        variant="top"
                                        src={
                                            doc.pfpPath ||
                                            "https://via.placeholder.com/150"
                                        }
                                        alt="Document Thumbnail"
                                    />
                                    <Card.Body>
                                        <Card.Title>{doc.requestedDoc}</Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted">
                                            {doc.requester} ({doc.ownerId})
                                        </Card.Subtitle>
                                        <Card.Text>
                                            <strong>Purpose:</strong>{" "}
                                            {doc.purpose}
                                            <br />
                                            <strong>Status:</strong>{" "}
                                            {doc.statusProcess}
                                            <br />
                                            <strong>Payment:</strong>{" "}
                                            {doc.statusPayment}
                                        </Card.Text>
                                        <Button variant="primary">
                                            View Details
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                    ) : (
                        <Col>
                            <p>No results for "{searchValue}"</p>
                        </Col>
                    )}
                </Row>
            </Container>

            {paginatedRequests.length > 0 && (
                <div className="pagination">
                    <button
                        onClick={() => changePage(1)}
                        disabled={pageNow === 1}
                    >
                        &lt;&lt;
                    </button>
                    <button onClick={pagePrev} disabled={pageNow === 1}>
                        &lt; Previous
                    </button>
                    {pageNumbers.map((number) => (
                        <button
                            key={number}
                            onClick={() => changePage(number)}
                            className={pageNow === number ? "active" : ""}
                        >
                            {number}
                        </button>
                    ))}
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>
                        Next &gt;
                    </button>
                    <button
                        onClick={() => changePage(pageTotal)}
                        disabled={pageNow === pageTotal}
                    >
                        &gt;&gt;
                    </button>
                </div>
            )}

            {/* TODO css class for position */}
            {/* TODO onclick modal add document */}
            <Button title="Add new document" onClick={' '} style={{ width: '50px', height: '50px', borderRadius: '50%' }} variant="dark" size="lg">+</Button>
        </div>
    );
}